import React from 'react';
import memoize from 'memoize-one';
import { ActiveDot, BasicActionBtns } from '../../components';

const columns = memoize(clickHandler => [
  {
    name: 'Código',
    selector: 'code',
    sortable: true,
    center: true
  },
  {
    name: 'Concepto',
    selector: 'name',
    sortable: true
  },
  {
    name: 'Cuenta Contable',
    selector: 'account',
    sortable: true,
    grow: '1'
  },
  {
    name: 'Cuenta Mayor',
    selector: 'major_account',
    sortable: true,
    grow: '1'
  },
  {
    name: 'Condición',
    selector: 'condition_code',
    sortable: true,
    grow: '1.2',
    center: true
  },
  {
    name: 'Imputación',
    selector: 'parsed_imputation',
    sortable: true,
    grow: '1',
    center: true
  },
  {
    name: 'Distribución',
    selector: 'translated_distribution',
    sortable: true,
    grow: '0.8',
    center: true
  },
  {
    name: 'Agrupado',
    selector: 'translated_grouped',
    sortable: true,
    grow: '0.8',
    center: true
  },
  {
    name: 'Activo',
    selector: 'active',
    cell: item => <ActiveDot item={item} />,
    sortable: true,
    grow: '0.5',
    center: true
  },
  {
    name: 'Acciones',
    cell: item => <BasicActionBtns item={item} resource="Bookkeeper" clickHandler={clickHandler} />,
    ignoreRowClick: true,
    allowOverflow: false,
    button: true,
    minWidth: '123px'
  }
]);

export default columns;
